import { DatePicker } from 'antd'
import moment from 'moment'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export const InputDate = (props) => {
  const {
    value,
    onChange,
    format,
    minDate = null,
    onBlur = () => {},
    defaultPickerValue,
  } = props

  // On change handler
  const check = (value) => {
    if (value) {
      if (format) onChange(parseInt(value.format(format)))
      else onChange(value.unix())
    } else onChange(value)
  }
  // Process incoming value to show in the control
  let newValue = {}
  if (typeof value == 'number' && format)
    newValue = { value: moment(value.toString(), format) }
  else if (typeof value == 'number') newValue = { value: moment.unix(value) }
  else if (value && typeof value == 'string' && !isNaN(value))
    newValue = { value: moment.unix(value) }

  // Apply validation
  const disabledSubmissionDate = (submissionValue) => {
    if (!submissionValue) return false
    if (minDate === null || typeof minDate === 'undefined') return false
    return submissionValue.valueOf() < minDate
  }
  // Render element
  return (
    <DatePicker
      onBlur={onBlur}
      {...newValue}
      disabledDate={disabledSubmissionDate}
      onChange={check}
      style={{ minWidth: '200px' }}
      format={'ll'}
      className="customDatePicker"
      {...(defaultPickerValue && !newValue.value ? { defaultPickerValue } : {})}
    />
  )
}

export const InputDateTime = (props) => {
  const {
    value,
    onChange,
    format,
    minDate = null,
    onBlur = () => {},
    defaultPickerValue,
  } = props
  const check = (value) => {
    if (value) {
      if (format) onChange(parseInt(value.format(format)))
      else onChange(value.unix())
    } else onChange(value)
  }
  let newValue = {}
  if (typeof value == 'number' && format)
    newValue = { value: moment(value.toString(), format) }
  else if (typeof value == 'number') newValue = { value: moment.unix(value) }
  else if (value && typeof value == 'string' && !isNaN(value))
    newValue = { value: moment.unix(value) }
  const disabledSubmissionDate = (submissionValue) => {
    if (!submissionValue) return false
    if (minDate === null || typeof minDate === 'undefined') return false
    return submissionValue.valueOf() < minDate
  }
  return (
    <DatePicker
      // {...props}
      {...newValue}
      onBlur={onBlur}
      disabledDate={disabledSubmissionDate}
      onChange={check}
      style={{ minWidth: '200px' }}
      showTime={true}
      className="customDatePicker"
      {...(defaultPickerValue && !newValue.value ? { defaultPickerValue } : {})}
    />
  )
}

export const InputDateRange = ({
  value,
  onChange,
  format,
  minDate = null,
  onBlur = () => {},
  defaultPickerValue,
}) => {
  const check = (value) => {
    if (value) {
      const [d1, d2] = value || []
      if (format) onChange(parseInt([d1?.format(format), d2?.format(format)]))
      else onChange([d1?.unix(), d2?.unix()])
    } else onChange(value)
  }
  let newValue = {}
  const [d1, d2] = value || []
  if (value?.length == 2 && format)
    newValue = {
      value: [moment(d1?.toString(), format), moment(d2?.toString(), format)],
    }
  else if (value?.length == 2 && typeof d1 == 'number')
    newValue = { value: [moment.unix(d1), moment.unix(d2)] }
  else if (value?.length == 2 && typeof d1 == 'string')
    newValue = { value: [moment(d1), moment(d2)] }

  const disabledSubmissionDate = (submissionValue) => {
    if (!submissionValue) return false
    if (minDate === null || typeof minDate === 'undefined') return false
    return submissionValue.valueOf() < minDate
  }
  return (
    <DatePicker.RangePicker
      {...newValue}
      onBlur={onBlur}
      disabledDate={disabledSubmissionDate}
      onChange={check}
      style={{ minWidth: '200px' }}
      format={'ll'}
      className="customDatePicker"
      {...(defaultPickerValue && !newValue.value ? { defaultPickerValue: [defaultPickerValue, defaultPickerValue] } : {})}
    />
  )
}

export const InputTime = (props) => {
  const { onChange, value, format = 'HH:mm A', onBlur = () => {} } = props
  const check = (time, timeString) => {
    onChange(timeString)
  }
  const stringVal = moment.isMoment(value) ? value.format(format) : value
  const valueProp = {}
  if (stringVal) valueProp['value'] = dayjs(stringVal, format)
  return (
    <DatePicker.TimePicker
      onChange={check}
      onBlur={onBlur}
      {...valueProp}
      format={format}
    />
  )
}
